import moment from 'moment';

/**
 * Format date to 'DD/MM/yyyy'
 * @param {string} date - date to be formatted 
 * @returns {string} formatted Date
 */
export function formatDate(date) {
	return moment(date).format('DD/MM/yyyy');
}

/**
 * Return an array for the items that is accepted by given function and an array for the items that aren't accepted.
 * @param {Array} array - Array with all items. 
 * @param {Function} fn - Function to evaluate items. 
 * @returns {Array} Array with separated list of items.
 */
export function filteredAndRejected(array, fn) {
	let filtered = new Array(array.length),
		rejected = new Array(array.length),
		i1 = 0,
		i2 = 0;

	array.forEach((p) => {
		if (fn(p)) {
			filtered[i1++] = p;
		} else {
			rejected[i2++] = p;
		}
	});

	filtered.length = i1;
	rejected.length = i2;

	return [filtered, rejected];
}

const HOLIDAYS = [
  "1-1", // new year
  "4-21", // tiradentes
  "5-1", // labour day
  "9-7", // independence day
  "10-12", // lady of aparecida day
  "11-2", // all souls' day
  "11-15", // republic proclamation day
  "12-25", // christmas
];

/**
 * Get difference between two dates in working days, that is, ignoring weekends and holidays.
 *
 * @param {Date} date1 - date to be compared (current date).
 * @param {Date} date2 - date to be compared (old date - fitExpiration reference).
 * @returns {Number} - number of days of difference ignoring weekends and holidays.
 */
export const getDifferenceInDaysWithTime = (date1, date2) => {
  const dates = [];
  let oldDate = new Date(date2);

  while (oldDate.getDate() < date1.getDate()) {
	const updatedDate = new Date(oldDate);
    dates.push(updatedDate);
    oldDate.setDate(oldDate.getDate() + 1);
  }

  const weekendDays = [0, 6]; // sunday and saturday
  let diffInDays = 0;

  dates.forEach((date) => {
    if (
      !weekendDays.includes(date.getDay()) &&
      !HOLIDAYS.includes(`${date.getMonth() + 1}-${date.getDate()}`)
    ) {
      diffInDays++;
    }
  });

  return diffInDays;
};

/**
 * Returns the username from an email address.
 *
 * @param {string} email - The email address to extract the username from.
 * @returns {string} The username extracted from the email address.
 */
export const getUserNameFromEmail = (email) => {
  return email.split('@')[0];
};